// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!./../../../node_modules/.npminstall/css-loader/0.23.1/css-loader/index.js!./../../../node_modules/.npminstall/postcss-loader/0.8.2/postcss-loader/index.js!./../../../node_modules/.npminstall/less-loader/2.2.3/less-loader/index.js!./example.less");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!./../../../node_modules/.npminstall/style-loader/0.13.1/style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!./../../../node_modules/.npminstall/css-loader/0.23.1/css-loader/index.js!./../../../node_modules/.npminstall/postcss-loader/0.8.2/postcss-loader/index.js!./../../../node_modules/.npminstall/less-loader/2.2.3/less-loader/index.js!./example.less", function() {
			var newContent = require("!!./../../../node_modules/.npminstall/css-loader/0.23.1/css-loader/index.js!./../../../node_modules/.npminstall/postcss-loader/0.8.2/postcss-loader/index.js!./../../../node_modules/.npminstall/less-loader/2.2.3/less-loader/index.js!./example.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/MainLayout/example.less
 ** module id = 672
 ** module chunks = 0
 **/